import useTheme from "@mui/material/styles/useTheme";
import { makeStyles } from "@mui/styles";

export const useCustomStyle = makeStyles(() => {
  const theme = useTheme();
  return {
    userListRowWrapper: {
      "&.userListRowWrapperInner": {
        padding: "0 10px 0 15px",
        width: "100%",
        "& .userlisttophead": {
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          alignItems: "center",
          margin: "15px 0px",
        },
        "& .assignee": {
          flex: 1,
          width: "160px",
          textAlign: "center",
          borderRight: "solid 1px #ccc",
          borderLeft: "solid 1px #ccc",
        },
        "& .userListRowItem": {
          minHeight: "72px",
          marginBottom: "14px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          cursor: "pointer",
          // border: `1px solid ${theme.palette.customColor.LINE}`,
          border: "1px solid #ced3d9",
          borderRadius: "4px",
          padding: "12px 20px",
          width: "100%",
          gap: 2,
          "&:hover": {
            border: `1px solid ${theme.palette.customColor.PRIMARY}`,
          },
          "& .textDescription": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
            wordBreak: "break-all",
          },
        },
        "& .skeltoncard": {
          "& .assignee": {
            border: "none",
          },
        },
      },
    },
  };
});
